Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div ref="reviewPageContainer" class="panel formio-review-page panel-default">\n  <div ref="header" class="panel-heading">\n    <h4 class="mb-0 panel-title">\n      ' +
((__t = (ctx.component.label)) == null ? '' : __t) +
'\n    </h4>\n  </div>\n  <div class="panel-body" ref="' +
((__t = (ctx.nestedKey)) == null ? '' : __t) +
'" id="' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'">\n    <ul>\n      ';
 ctx.component.reviewFields.forEach(function(row, rowIndex) { ;
__p += '\n        ';
 if (ctx.options.building || row.visible) { ;
__p += ' \n          <li>\n            <strong>' +
((__t = (row.label)) == null ? '' : __t) +
'</strong> :\n            ';
 if (ctx.options.building) { ;
__p += ' \n              data.' +
((__t = (row.path)) == null ? '' : __t) +
'\n            ';
 } ;
__p += '\n            ';
 if (!ctx.options.building) { ;
__p += ' \n              ' +
((__t = (row.data)) == null ? '' : __t) +
'\n            ';
 } ;
__p += '\n          </li>\n        ';
 } ;
__p += '\n      ';
 }) ;
__p += '\n    </ul>\n  </div>\n</div>\n\n';
return __p
}